import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Header from '../components/Header'
import { motion } from 'framer-motion'

export default function PageWrapper(props) {
    return (
        <Container>
            <Row>
                <Col xs={{ offset: 1 }} md={{ offset: 0 }}>
                    <Header></Header> 
                    {/* <hr className='mt-0' /> */}
                </Col>
            </Row>
            <Row className='text-center text-dark parallax-text w-100 mt-4'>
                <Col xs={{ offset: 1 }} md={{ offset: 0 }}>
                    <motion.div
                        className='text-light display-3 fw-bold'
                        initial={{y: '-50vh'}} 
                        animate={{y: 0}} 
                        transition={{ delay: .25, ease: 'easeInOut'}}>{props.display}
                    </motion.div>
                    <motion.p
                    className='text-light display-5 lead'
                        initial={{y: '-50vh'}} 
                        animate={{y: 0}} 
                        transition={{ delay: .5, ease: 'easeInOut'}}>
                        { props.children }
                    </motion.p>
                </Col>
            </Row>      

        </Container>)
}
